import _objectAssign from './_objectAssign';

export default typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_assign.js
// module id = 205
// module chunks = 1